export default "__VITE_ASSET__c626639f__"